import { domain } from 'modules/data';

export const sortedIntegrationCodes: domain.IntegrationCode[] = [
    domain.IntegrationCode.XeroPo,
    domain.IntegrationCode.XeroBill,
    domain.IntegrationCode.XeroAmaxPayBatchPayment,
    domain.IntegrationCode.XeroBillBatchPayment,
    domain.IntegrationCode.XeroAirwallexBatchPayment,
    domain.IntegrationCode.XeroQuote,
    domain.IntegrationCode.XeroInvoice,
    domain.IntegrationCode.XeroCreditNotesPayable,
    domain.IntegrationCode.XeroCreditNotesReceivable,
    domain.IntegrationCode.XeroContact,
    domain.IntegrationCode.QBooksPo,
    domain.IntegrationCode.QBooksBill,
    domain.IntegrationCode.QBooksInvoice,
    domain.IntegrationCode.QBooksVendor,
    domain.IntegrationCode.QBooksExpense,
    domain.IntegrationCode.QBooksJournalEntry,
    domain.IntegrationCode.NetSuitePO,
    domain.IntegrationCode.NetSuiteBill,
    domain.IntegrationCode.DearPo,
    domain.IntegrationCode.NetSuiteSalesOrder,
    domain.IntegrationCode.NetSuiteInvoice,
    domain.IntegrationCode.NetSuiteItemReceipt,
    domain.IntegrationCode.NetSuiteExpenseReport,
    domain.IntegrationCode.NetSuiteVRA,
    domain.IntegrationCode.NetSuiteBillPayment,
    domain.IntegrationCode.NetSuiteRA,
    domain.IntegrationCode.XeroManualJournal,
    domain.IntegrationCode.NetSuiteJournalEntry,
    domain.IntegrationCode.NetSuiteVendor,
];
